<div class="cardModal">
    <div class="cardTitle">
        <h3>{{ 'users.shijiUsers.create.inviteShijiUsers' | translate }}</h3>
    </div>

    <div class="cardContent">
        <form [formGroup]="newUserForm">
            <div class="inputGroup labelTop">
                <label for="emails">{{ 'users.emails' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error [parentForm]="newUserForm" [controlPath]="'emails'" />
                    <textarea id="emails" formControlName="emails" [placeholder]="'users.shijiUsers.create.emailsPlaceholder' | translate">
                    </textarea>
                </div>
            </div>

            <div class="inputGroup">
                <label for="doNotEmail" class="label">{{ 'users.shijiUsers.create.doNotEmail' | translate }}</label>
                <input type="checkbox" id="doNotEmail" formControlName="doNotEmail" />
            </div>
        </form>
    </div>
    <div class="cardFooter">
        <div class="buttonArea">
            <button type="submit" class="button primary" (click)="inviteShijiUser()">
                {{ 'users.shijiUsers.create.invite' | translate }}
            </button>
            <button type="button" class="button" (click)="closeModal()">{{ 'generalKeywords.cancel' | translate }}</button>
        </div>
    </div>
</div>
